import React from "react";
import { useNavigate } from "react-router-dom";
import {
  AiFillContacts,
  AiFillDashboard,
  AiFillDollarCircle,
  AiFillEdit,
  AiFillShopping,
  AiOutlineFileText,
  AiOutlineHome,
  AiOutlineLogout,
} from "react-icons/ai";

const navItems = [
  { label: "Dashboard", href: "/admin", icon: AiFillDashboard },
  { label: "Users", href: "/admin/user", icon: AiFillContacts },
  { label: "Questions", href: "/admin/practice", icon: AiFillEdit },
  { label: "Posts", href: "/admin/post", icon: AiOutlineFileText },
  { label: "Products", href: "/admin/product", icon: AiFillShopping },
  { label: "Dynamic Price", href: "/admin/product/price", icon: AiFillDollarCircle },
];

export default function Sidebaradmin() {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;

  const handleLogout = async () => {
    try {
      const response = await fetch("/logout", {
        method: "GET",
        credentials: "include",
      });

      if (response.status === 200) {
        navigate("/login");
      } else {
        console.error("Logout Failed");
      }
    } catch (error) {
      console.error("Error During Logout:", error);
    }
  };

  return (
    <aside className="relative w-full shrink-0 border-b border-slate-200 bg-white px-4 py-4 shadow-sm md:sticky md:top-0 md:h-screen md:w-72 md:border-b-0 md:border-r md:py-5">
      <div className="mb-4 flex items-center gap-3 px-2 md:mb-8">
        <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-slate-950 text-lg font-bold text-white">
          PN
        </div>
        <div>
          <h1 className="text-lg font-bold leading-tight text-slate-950">PrepNexis</h1>
          <p className="text-sm text-slate-500">Admin console</p>
        </div>
      </div>

      <nav className="flex gap-2 overflow-x-auto pb-1 md:block md:space-y-1 md:overflow-visible md:pb-0">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPath === item.href;

          return (
            <a
              key={item.href}
              href={item.href}
              className={`flex shrink-0 items-center gap-3 rounded-lg px-3 py-3 text-sm font-semibold transition ${
                isActive
                  ? "bg-sky-50 text-sky-700 ring-1 ring-sky-100"
                  : "text-slate-600 hover:bg-slate-50 hover:text-slate-950"
              }`}
            >
              <Icon className="text-xl" />
              <span>{item.label}</span>
            </a>
          );
        })}
      </nav>

      <div className="mt-4 flex gap-2 overflow-x-auto border-t border-slate-100 pt-4 md:absolute md:bottom-5 md:left-4 md:right-4 md:mt-0 md:block md:space-y-2 md:overflow-visible md:border-t-0 md:pt-0">
        <button
          type="button"
          onClick={() => navigate("/dashboard")}
          className="flex shrink-0 items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-3 py-3 text-sm font-semibold text-slate-700 transition hover:bg-white hover:text-slate-950 md:w-full"
        >
          <AiOutlineHome className="text-xl" />
          <span>User Dashboard</span>
        </button>

        <button
          type="button"
          onClick={handleLogout}
          className="flex shrink-0 items-center gap-3 rounded-lg border border-rose-100 bg-rose-50 px-3 py-3 text-sm font-semibold text-rose-700 transition hover:bg-rose-100 md:w-full"
        >
          <AiOutlineLogout className="text-xl" />
          <span>Logout</span>
        </button>

        <div className="hidden rounded-lg border border-slate-200 bg-slate-50 p-4 md:block">
          <p className="text-sm font-semibold text-slate-950">System status</p>
          <div className="mt-3 flex items-center gap-2 text-sm text-emerald-700">
            <span className="h-2.5 w-2.5 rounded-full bg-emerald-500" />
            All services running
          </div>
        </div>
      </div>
    </aside>
  );
}
